var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3057_12842)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_3057_12842)",
    d: "M20.01 8.4c-.45-1.06-1.08-2-1.9-2.81a9 9 0 0 0-2.81-1.9 8.95 8.95 0 0 0-6.89 0c-1.05.45-2 1.08-2.81 1.9-.81.81-1.45 1.76-1.9 2.81-.46 1.09-.7 2.25-.7 3.45 0 1.51.39 2.99 1.12 4.31l-1.08 3.33c-.11.33-.02.69.23.93s.61.33.93.23l3.34-1.08c1.31.73 2.8 1.12 4.31 1.12 1.19 0 2.35-.23 3.45-.7 1.05-.45 2-1.08 2.81-1.9s1.45-1.76 1.9-2.81c.46-1.09.7-2.25.7-3.45s-.23-2.35-.7-3.45zM6 16.33a.91.91 0 0 0-.1-.77 7 7 0 0 1-1.06-3.71 7 7 0 0 1 2.05-4.96 6.97 6.97 0 0 1 4.96-2.05c1.88 0 3.63.73 4.95 2.05a6.97 6.97 0 0 1 2.05 4.96c0 1.88-.73 3.63-2.05 4.95a6.96 6.96 0 0 1-4.95 2.05c-1.32 0-2.6-.37-3.71-1.06a.96.96 0 0 0-.77-.1l-2.02.65.65-2.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M11.85 12.94c.6 0 1.09-.49 1.09-1.09s-.49-1.09-1.09-1.09-1.09.49-1.09 1.09.49 1.09 1.09 1.09M15.21 12.94c.6 0 1.09-.49 1.09-1.09s-.49-1.09-1.09-1.09-1.09.49-1.09 1.09.49 1.09 1.09 1.09M8.49 12.94c.6 0 1.09-.49 1.09-1.09s-.49-1.09-1.09-1.09-1.09.49-1.09 1.09.49 1.09 1.09 1.09"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3057_12842",
    x1: 11.852,
    x2: 11.852,
    y1: 3,
    y2: 20.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3C78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1A60"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3057_12842"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3 3h17.7v17.7H3z"
  })))));
};
export default SvgChat;